import { logStartGreyError } from 'owa-analytics-start';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import folderIdToName from './folderIdToName';

export default function doesFolderIdEqualName(
    folderId: string,
    distinguishedFolderName: DistinguishedFolderIdName,
    shouldSearchShared?: boolean
): boolean {
    if (!folderId) {
        const error = new Error('DoesFolderIdEqualNameInvalidParameters');

        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *      > Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logStartGreyError('DoesFolderIdEqualNameInvalidParameters', undefined, error);

        return false;
    }

    return folderIdToName(folderId, shouldSearchShared) === distinguishedFolderName;
}
